'use client';

import { useRef } from 'react';
import ConditionalTile from '~/constants/srp/ConditionalTile';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import { type NewCarVariant } from '~/utilities/srp/new-car/getNewCarVariant';
import { genericTileBackground } from './genericTileBackground';
import RotatingBrandLogo from './RotatingBrandLogo';
import {
  BlueFillerBackground,
  ContentContainer,
  StyledLink,
  TileCta
} from '../NewCarTile.styles';
import ObservableTile from '../ObservableTile';

type OwnProps = {
  href: string;
  position: number;
  variant: NewCarVariant;
};

export default function GenericNewCarTile({
  position,
  href,
  variant
}: OwnProps) {
  const trackEvent = useTrackEvent();
  const observeRef = useRef(null);

  return (
    <ObservableTile
      observeRef={observeRef}
      name={ConditionalTile.NewCarConfigurator}
      onVisible={() =>
        trackEvent('Conditional tile', {
          action: 'viewed',
          position,
          tile: ConditionalTile.NewCarConfigurator,
          variant
        })
      }
    >
      <StyledLink
        id={ConditionalTile.NewCarConfigurator}
        className="bg-position-[center_bottom_64px] bg-size-[390%_460px]"
        data-testid="conditional-tile-link"
        data-adobe-id="new-car-tile-select-color-options-more"
        data-analytics-id="Conditional Tile"
        data-analytics-attributes={JSON.stringify({
          position,
          tile: ConditionalTile.NewCarConfigurator,
          variant
        })}
        href={href}
        style={{ backgroundImage: `url("${genericTileBackground}")` }}
      >
        <BlueFillerBackground aria-hidden="true" />

        <ContentContainer>
          <div className="flex flex-col gap-lg">
            <RotatingBrandLogo />
            <h3 className="t-brand-xs md:t-brand-md uppercase text-text-inverse">
              discover <span className="text-brand-tertiary">new car</span>{' '}
              shopping
            </h3>
            <p className="t-body-sm text-text-inverse">
              Build your perfect ride — pickup or delivery as soon as today!
            </p>
          </div>

          <TileCta aria-hidden="true" tabIndex={-1}>
            Select Color, Options & More
          </TileCta>
        </ContentContainer>
      </StyledLink>
    </ObservableTile>
  );
}
